import { render } from "./CurrencyDisplay.vue?vue&type=template&id=065f8a6e"
import script from "./CurrencyDisplay.vue?vue&type=script&lang=js"
export * from "./CurrencyDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__